import baseApi from "./RootBaseApi";
import {
  EmailLayoutResponse,
  EmailLayoutListApiResponse,
  UpdateEmailLayoutPayload,
} from "@/types/email-layout.types";

export const EmailLayoutService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // List all layouts (supports pagination), API: GET /email-layouts
    getEmailLayouts: builder.query<
      EmailLayoutListApiResponse,
      { page?: number; limit?: number }
    >({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: "template-layouts",
        method: "GET",
        params: { page, limit },
      }),
      providesTags: ["EmailLayout"],
      keepUnusedDataFor: 0,
    }),
    updateEmailLayout: builder.mutation<
      EmailLayoutResponse,
      {
        id: string;
        body: UpdateEmailLayoutPayload;
        xLang?: "en" | "fi" | "de" | "sv";
        headers?: Record<string, string | number>;
      }
    >({
      query: ({ id, body, xLang = "en", headers = {} }) => ({
        url: `template-layouts/${id}`,
        method: "PATCH",
        data: body,
        headers: { "x-lang": xLang, ...headers },
      }),
      invalidatesTags: ["EmailLayout"],
    }),
  }),
});

export const { useGetEmailLayoutsQuery, useUpdateEmailLayoutMutation } =
  EmailLayoutService;
